<template>
  <el-card>
    <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('名称')" prop="name">
        <el-input :placeholder="$t('名称')" v-model="formData.name" />
      </el-form-item>

      <el-form-item :label="$t('内容')" class="rich-text-row" prop="content">
        <wangeditor ref="editor" v-model="formData.content" :upload-img-server="$api.file.uploadEditor" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{$t('确定')}}</el-button>
        <el-button @click="resetForm">{{$t('重置')}}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import Wangeditor from "@/components/Wangeditor";
import {request} from "@/config/request";
import {resetEmpty} from "@/utils/common";
export default {
  name: "RichTextEdit",
  components: {Wangeditor},
  data() {
    return {
      formData:  {
        name: "",
        content: "",
      },
      rules: {
        name: {required: true, message: this.$t('请输入名称'), trigger: 'blur'},
        content: {required: true, message: this.$t('请输入内容'), trigger: 'blur'}
      },
    }
  },
  methods: {
    // 提交
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          const params  = {...this.formData};
          delete params.createTime;
          delete params.updateTime;
          await request(this.$api.richText.update, params);
          this.$message.success(this.$t('操作成功'));
          this.$router.back();
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.$refs.editor.clear();
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.richText.detail, this.$route.query);
        this.formData = res.richText;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 400px;
}

.rich-text-row {
  width: 900px;
}

</style>
